import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import { Link, useLocation, useNavigate, NavLink } from "react-router-dom";
import React, { useState, useEffect, useRef, useContext } from "react";
import "./Header.css";
import Logout_Modal from "./logout/Logout_Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { Context } from "../../utils/context";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../features/admin/auth/Slice";
import Cookies from "js-cookie";
import { IDS } from "../../utils/IDS";
import { Form } from "react-bootstrap";
import { availableToday } from "../../features/admin/vendor_expert/Slice";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signin, setSignin, setUserData, userdata } = useContext(Context);
  console.log(userdata, "userdatauserdatauserdatauserdata");

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isAvailable, setIsAvailable] = useState(false);
  const [selectedLang, setSelectedLang] = useState("en"); // default language
  const [locationName, setLocationName] = useState("");
  const isLoginPage = location.pathname === "/login";

  useEffect(() => {
    const fetchLocation = () => {
      if (
        userdata?.lat &&
        userdata?.long &&
        window.google &&
        window.google.maps
      ) {
        const geocoder = new window.google.maps.Geocoder();

        const latlng = {
          lat: parseFloat(userdata.lat),
          lng: parseFloat(userdata.long),
        };

        geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === "OK" && results[0]) {
            const cityComponent = results[0].address_components.find((comp) =>
              comp.types.includes("locality"),
            );

            setLocationName(
              cityComponent?.long_name || results[0].formatted_address,
            );
          } else {
            setLocationName("Location not found");
          }
        });
      }
    };

    // Wait until Google loads
    const interval = setInterval(() => {
      if (window.google && window.google.maps) {
        fetchLocation();
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [userdata]);

  const handleToggleAvailable = () => {
    const newStatus = !isAvailable;

    setIsAvailable(newStatus);

    dispatch(
      availableToday({
        available_today: newStatus ? 1 : 0,
      }),
    );
  };

  const dropdownRef = useRef(null);

  const handleNavClick = () => {
    setExpanded(false);
    setIsProfileOpen(false);
  };

  const handleLogout = () => {
    Cookies.remove("ots_website_security", { path: "/" });

    setSignin(false);
    setUserData({});
    dispatch(logoutUser());
    setIsProfileOpen(false);
  };

  const isHomePage = location.pathname === "/";
  const isDetailsPage =
    location.pathname === "/Expert_Login_Details" ||
    location.pathname === "/vendor-login-details" ||
    location.pathname === "/expert-login-details";

  const showAuthButtons = !signin && (isHomePage || isDetailsPage);

  const handleSubscriptionClick = () => {
    navigate("/login");
  };

  // Close profile dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isProfileOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isProfileOpen]);

  const clearGoogleCookies = () => {
    const domains = [
      "", // current domain
      "otswebsite.profcymadev.com",
      ".profcymadev.com",
    ];

    const paths = ["/"];

    domains.forEach((domain) => {
      paths.forEach((path) => {
        document.cookie = `googtrans=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path}${
          domain ? `;domain=${domain}` : ""
        }`;
      });
    });
  };

  const changeLanguage = (lang) => {
    clearGoogleCookies(); // 🔥 important

    // ✅ ONLY set on parent domain
    document.cookie = `googtrans=/en/${lang};path=/;domain=.profcymadev.com`;

    document.cookie = `ots_language=${lang};path=/;domain=.profcymadev.com`;

    localStorage.setItem("lang", lang);

    setSelectedLang(lang);

    window.location.reload();
  };

  useEffect(() => {
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        return parts
          .pop()
          .split(";")
          .shift();
      }
    };

    const savedLang =
      getCookie("ots_language") || localStorage.getItem("lang") || "en";

    setSelectedLang(savedLang);

    // ✅ apply translation cookie correctly
    document.cookie = `googtrans=/en/${savedLang};path=/;domain=.profcymadev.com`;
  }, []);

  useEffect(() => {
    if (userdata?.type === "expert") {
      setIsAvailable(!!userdata?.available_today);
    }
  }, [userdata]);
  return (
    <section className="main_head">
      <div className="container-fluid p-0">
        <Navbar
          expand="lg"
          expanded={expanded}
          onToggle={(val) => setExpanded(val)}
          bg="white"
          className="header"
        >
          <Container className="g-0">
            <Navbar.Brand
              onClick={() => {
                if (userdata?.type === "customer") {
                  navigate("/");
                } else if (userdata?.type === "vendor") {
                  navigate("/vendor-login-details");
                } else if (userdata?.type === "expert") {
                  navigate("/expert-login-details");
                } else {
                  navigate("/");
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/assets/header/nova-prime-logo.png"
                alt="Nova prime"
                className="header-logo"
              />
            </Navbar.Brand>

            <div className="nav-actions-container order-md-2">
              {showAuthButtons ? (
                <div className="subscription-holder">
                  <Button
                    className="subscription-btn"
                    onClick={handleSubscriptionClick}
                  >
                    <img
                      src="/assets/header/crown (2).png"
                      alt="Premium"
                      className="crown-icon"
                    />
                    Subscription
                  </Button>

                  <Button
                    className="login-btn ms-2"
                    onClick={() => navigate("/login")}
                  >
                    Log In
                  </Button>
                </div>
              ) : signin ? (
                <>
                  <div className="toggle_holder">
                    <div className="header-profile" ref={dropdownRef}>
                      <div
                        className="profile-trigger-wrapper"
                        onClick={() => setIsProfileOpen(!isProfileOpen)}
                      >
                        <div className="profile-trigger">
                          <img
                            src={
                              userdata?.profile_pic
                                ? `${IDS.IMG_URL}/${userdata?.profile_pic}`
                                : "/assets/images/profile-icon.png"
                            }
                            alt="Profile"
                            className="profile-avatar"
                          />
                        </div>

                        <div className="profile-holder">
                          <span className="profile-name">
                            {userdata?.name || "User"}
                          </span>
                          <div className="dropdown-icon">
                            <FontAwesomeIcon icon={faSortDown} />
                          </div>
                        </div>
                      </div>

                      {isProfileOpen && (
                        <div className="profile-dropdown-menu">
                          <Link
                            to="/profile"
                            className="profile-item"
                            onClick={handleNavClick}
                          >
                            Profile
                          </Link>

                          <div className="profile-divider"></div>

                          <Link
                            to="/wallet"
                            className="profile-item"
                            onClick={handleNavClick}
                          >
                            Subscription
                          </Link>

                          <div className="profile-divider"></div>

                          <Link
                            to="/history"
                            className="profile-item"
                            onClick={handleNavClick}
                          >
                            History
                          </Link>

                          <div className="profile-divider"></div>

                          <Link
                            to="/notification-page"
                            className="profile-item"
                            onClick={handleNavClick}
                          >
                            Notification
                          </Link>

                          <div className="profile-divider"></div>

                          <div
                            className="profile-item logout-text"
                            onClick={() => {
                              setShowLogoutModal(true);
                              handleNavClick();
                            }}
                          >
                            Logout
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : null}
            </div>

            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="ms-2 order-md-3"
            />

            <Navbar.Collapse id="basic-navbar-nav" className="order-md-1">
              <Nav className="mx-auto text-center mobile-nav-links">
                <Nav.Link
                  as={NavLink}
                  to={
                    signin && userdata?.type === "vendor"
                      ? "/vendor-login-details"
                      : signin && userdata?.type === "expert"
                      ? "/expert-login-details"
                      : "/"
                  }
                  onClick={handleNavClick}
                >
                  Home
                </Nav.Link>

                {!isDetailsPage && <></>}

                <Nav.Link as={NavLink} to="/aboutus" onClick={handleNavClick}>
                  About Us
                </Nav.Link>

                <Nav.Link as={NavLink} to="/contactus" onClick={handleNavClick}>
                  Contact Us
                </Nav.Link>
                <div className="language-dropdown-mobile">
                  {locationName && !isLoginPage && (
                    <span className="user-location me-2">
                      📍 {locationName}
                    </span>
                  )}
                  <select
                    value={selectedLang}
                    onChange={(e) => changeLanguage(e.target.value)}
                    className="form-select"
                    translate="no"
                  >
                    <option value="en">English</option>
                    <option value="hi">Hindi</option>
                    <option value="mr">Marathi</option>
                  </select>
                </div>
              </Nav>

              <div
                className="language-dropdown-desktop"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {locationName && !isLoginPage && (
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#333",
                      fontWeight: "500",
                      whiteSpace: "nowrap",
                    }}
                  >
                    📍 {locationName}
                  </span>
                )}

                <select
                  value={selectedLang}
                  onChange={(e) => changeLanguage(e.target.value)}
                  className="form-select"
                  style={{ width: "120px" }}
                  translate="no"
                >
                  <option value="en">English</option>
                  <option value="hi">Hindi</option>
                  <option value="mr">Marathi</option>
                </select>
              </div>
            </Navbar.Collapse>
          </Container>

          <Logout_Modal
            show={showLogoutModal}
            handleClose={() => setShowLogoutModal(false)}
            handleLogout={handleLogout}
          />
        </Navbar>
      </div>
      <div className="extra_div">
        <div className="container">
          {userdata?.type === "expert" && (
            <Form className="switch_holder">
              <Form.Check
                type="switch"
                checked={isAvailable}
                onChange={handleToggleAvailable}
              />

              <span className="inner_text">
                Available Today: {isAvailable ? "Active" : "Inactive"}
              </span>
            </Form>
          )}
        </div>
      </div>
    </section>
  );
};

export default Header;
